// Note this module is needed as the anchor.hash is not appended in the URL in svelte-routing

import { navigate } from "svelte-routing";

export const scrollPositions = new Map();

// svelte seems to kill anchor.host value in ie11, so fall back to checking href
const hostMatches = (anchor) => {
  const host = location.host;
  return (
    anchor.host === host ||
    anchor.href.indexOf(`https://${host}`) === 0 ||
    anchor.href.indexOf(`http://${host}`) === 0
  );
};

/**
 * Decides whether a given `event` should result in a navigation or not.
 * @param {object} event
 */
const shouldNavigate = (event) =>
  !event.defaultPrevented &&
  event.button === 0 &&
  !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

export function createAnchorScroller() {
  const anchorID = document.location.hash.replace(/^\#/, "");
  const anchor = document.getElementById(anchorID);

  let raf = requestAnimationFrame(() => {
    raf = null;
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(
        null,
        null,
        window.location.pathname + window.location.search
      );
    }
  });
  return () => {
    if (raf != null) {
      cancelAnimationFrame(raf);
      raf = null;
    }
  };
}

export const link = (node) => {
  const onClick = (event) => {
    const anchor = event.currentTarget;

    if (
      (anchor.target === "" || anchor.target === "_self") &&
      hostMatches(anchor) &&
      shouldNavigate(event)
    ) {
      event.preventDefault();
      console.log(
        "NAV",
        window.location.pathname,
        document.documentElement.scrollTop
      );
      scrollPositions.set(
        window.location.pathname,
        document.documentElement.scrollTop
      );
      navigate(anchor.pathname + anchor.search + anchor.hash, {
        replace: anchor.hasAttribute("replace"),
        preserveScroll: anchor.hasAttribute("preserveScroll"),
      });
    }
  };

  node.addEventListener("click", onClick, { passive: false });
  return {
    destroy() {
      node.removeEventListener("click", onClick);
    },
  };
};
